import React, { useState, useEffect } from 'react';
import { Toast } from 'antd-mobile-v5'
import styles from './index.module.scss'

const Live = (props: any) => {


    useEffect(() => {
        window.document.title = '自测工具'
    }, [])



    return (
        <div className={styles.toolsContainer}>
            自测工具
        </div>
    )
}

export default Live;